<template>
  <div>
    <Pane />
    <a-card class="container">
      <a-form-model layout="inline" @keyup.enter.native="query">
        <a-row>
          <a-col :span="22">
            <a-form-model-item>
              <a-select v-model="form.date" placeholder="请选择年份" style="width: 150px">
                <a-select-option v-for="item in [2026,2025]" :key="item" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item>
              <a-space>
                <a-button @click="query" type="primary">查询</a-button>
              </a-space>
            </a-form-model-item>
          </a-col>
          <a-col :span="2">
            <div class="right" style="margin-top: 4px">
              <a-button @click="download" type="primary">导出汇总台账</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form-model>

      <Padding />

      <a-table
        bordered
        :dataSource="list"
        :loading="loading"
        @change="onChange"
        :pagination="{
          total,
          current,
          pageSize,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
      >
        <a-table-column title="部门">
          <template slot-scope="text">
            <a-button type="link" @click="$router.push($route.path + '/department?year=' + form.date + '&deptName=' + text.departmentName)">{{ text.departmentName }}</a-button>
          </template>
        </a-table-column>
        <a-table-column title="1月" data-index="januaryAmount"> </a-table-column>
        <a-table-column title="2月" data-index="februaryAmount"> </a-table-column>
        <a-table-column title="3月" data-index="marchAmount"> </a-table-column>
        <a-table-column title="4月" data-index="aprilAmount"> </a-table-column>
        <a-table-column title="5月" data-index="mayAmount"> </a-table-column>
        <a-table-column title="6月" data-index="juneAmount"> </a-table-column>
        <a-table-column title="7月" data-index="julyAmount"> </a-table-column>
        <a-table-column title="8月" data-index="augustAmount"> </a-table-column>
        <a-table-column title="9月" data-index="septemberAmount"> </a-table-column>
        <a-table-column title="10月" data-index="octoberAmount"> </a-table-column>
        <a-table-column title="11月" data-index="novemberAmount"> </a-table-column>
        <a-table-column title="12月" data-index="decemberAmount"> </a-table-column>
        <a-table-column title="合计">
          <template slot-scope="text">
            {{ text.januaryAmount + text.februaryAmount + text.marchAmount + text.aprilAmount + text.mayAmount + text.juneAmount + text.julyAmount + text.augustAmount + text.septemberAmount + text.octoberAmount + text.novemberAmount + text.decemberAmount }}
          </template>
        </a-table-column>
      </a-table>  
    </a-card>
  </div>
</template>

<script>
import watermark from "@/mixins/watermark";
import { fetchApplyList, fetchWareList, downloadFile } from "@/api/oa/purchaseMaterials";
import { downloadByHtml } from "@/utils/xlsx";
import { saveAs } from "file-saver";
import organization from "@/mixins/organization";
import moment from "moment";
export default {
  name: "materialList",
  mixins: [watermark,organization],

  data() {
    return {
      active: "tab1",
      form: {},
      loading: false,
      list: [],
      current: 1,
      pageSize: 10,
      listB: [],
      total: 0,
    };
  },

  mounted() {
    // 本月第一天和本月最后一天
    const year = moment().year();
    const month = moment().month();

    this.form = {
      date: 2026,
    };

    this.getList();
    this.getListB();
  },

  methods: {
    getList() {
      const { date } = this.form;

      let startTime, endTime;
      if (Array.isArray(date) && date.length === 2) {
        startTime = date[0].format("YYYY-MM-DD");
        endTime = date[1].format("YYYY-MM-DD");
      }

      this.loading = true;
      fetchApplyList(date)
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res) && Array.isArray(res)) {

            this.list = res

          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getListB();
    },
    getListB() {
      const { date,deptId } = this.form;
      let startDate, endDate;
      if (Array.isArray(date) && date.length === 2) {
        startDate = date[0].format("YYYY-MM-DD");
        endDate = date[1].format("YYYY-MM-DD");
      }
      fetchWareList({
        deptId: deptId,
        pageNum: this.current,
        pageSize: this.pageSize,
        startDate,
        endDate,
      })
        .then((res) => {
          this.loading = false;
          this.listB = res.list;
          this.total = res.totalSize ? res.totalSize : 0;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    queryB() {
      this.current = 1;
      this.getListB();
    },
    resetB() {
      this.form = {};
      this.getListB();
    },

    query() {
      this.getList();
    },
    reset() {
      this.form = {};
      this.getList();
    },

    download() {
      downloadFile(this.form.date).then(blob => {
        saveAs(blob, "导出结果.xlsx");
      });
    },

    setPath(record) {
      let url = this.$route.path + "/detail?deptId=" + record.deptId;

      const { date } = this.form;
      let startTime, endTime;
      if (Array.isArray(date) && date.length === 2) {
        startTime = date[0].format("YYYY-MM-DD");
        endTime = date[1].format("YYYY-MM-DD");
        url = `${url}&startTime=${startTime}&endTime=${endTime}`;
      }
      return url;
    },
  },
};
</script>

